import React from "react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import TextField from "../components/TextField";
import Snackbar from "../components/Snackbar";
import Typography from "../components/Typography";
import Button from "../components/Button";
import { Formik, Form } from "formik";
import * as y from "yup";
import firebase from "firebase";
import "firebase/analytics";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(15),
      paddingBottom: theme.spacing(15),
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        paddingTop: theme.spacing(8),
      },
    },
    cardWrapper: {
      zIndex: 1,
    },
    card: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: theme.palette.warning.main,
      padding: theme.spacing(8, 3),
    },
    cardContent: {
      maxWidth: 400,
    },
    textField: {
      width: "100%",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(2),
    },
    button: {
      width: "100%",
    },
  });

const initialValues = {
  email: "",
};

const formSchema = y
  .object({
    email: y.string().email("invalid email").required(),
  })
  .required();

function StayInTouch(props: WithStyles<typeof styles>) {
  const { classes } = props;
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container className={classes.root} component="section">
      <Grid container justify="center">
        <Grid item xs={12} md={6} className={classes.cardWrapper}>
          <div className={classes.card}>
            <Formik
              initialValues={initialValues}
              validationSchema={formSchema}
              onSubmit={async (values, actions) => {
                setOpen(true);
                const { email } = values;
                const { data } = await firebase
                  .functions()
                  .httpsCallable("addNewEmail")({
                  email,
                });
                firebase
                  .analytics()
                  .logEvent("new subscriber", { outcome: data });
              }}
            >
              {(formikProps) => (
                <Form
                  noValidate
                  onSubmit={formikProps.handleSubmit}
                  className={classes.cardContent}
                >
                  <Typography
                    variant="h2"
                    component="h2"
                    gutterBottom
                    align="center"
                  >
                    Stay in touch
                  </Typography>
                  <Typography variant="h5" align="center">
                    Get tips, tricks, and best practices for building with
                    React, Typescript, Material UI, and Firebase straight to
                    your inbox.
                  </Typography>
                  <TextField
                    noBorder
                    name="email"
                    size="large"
                    className={classes.textField}
                    placeholder="your email"
                    onBlur={formikProps.handleBlur}
                    onChange={formikProps.handleChange}
                    value={formikProps.values.email}
                    label={
                      formikProps.touched.email && formikProps.errors.email
                    }
                    error={!!formikProps.errors.email}
                  />
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    size="large"
                    className={classes.button}
                    disabled={formikProps.isSubmitting}
                  >
                    Keep me updated
                  </Button>
                </Form>
              )}
            </Formik>
          </div>
        </Grid>
      </Grid>
      <Snackbar
        open={open}
        closeFunc={handleClose}
        message="Thanks for subscribing! Please check your inbox for confirmation."
      />
    </Container>
  );
}

export default withStyles(styles)(StayInTouch);
